<template>
  <v-select
    flat
    dense
    outlined
    hide-details
    class="font-size-14"
    append-icon="mdi-chevron-down"
    :value="priority"
    :items="priorities"
    :label="$t('common.priority')"
    :placeholder="$t('common.select')"
    @change="$emit('change', $event)"
  />
</template>

<script>
export default {
  name: 'PrioritySelector',

  props: {
    priority: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      priorities: [
        {
          value: 'high',
          text: this.$t('rev.priority.high'),
        },
        {
          value: 'medium',
          text: this.$t('rev.priority.medium'),
        },
        {
          value: 'low',
          text: this.$t('rev.priority.low'),
        },
        {
          value: null,
          text: this.$t('rev.priority.none'),
        },
      ],
    }
  },
}
</script>
